import { Link } from "react-router-dom";

const stats = [
  { value: "1,200+", label: "收录影视作品" },
  { value: "3,600+", label: "分集剧情整理" },
  { value: "每日", label: "更新剧集动态" },
  { value: "6 大", label: "主流地区内容" },
];

export default function SiteIntro() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-primary-950">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div>
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-800 text-accent-300 text-xs font-medium mb-4">
            <i className="ri-compass-3-line"></i>
            关于本站
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-tight">
            一个专注影视剧情介绍的 <br className="hidden md:block" />
            内容资讯平台
          </h2>
          <p className="mt-4 text-sm md:text-base text-background-200/90 leading-relaxed">
            “邻居的妻子影视大全”致力于为影视爱好者整理清晰、详尽的作品资料。我们围绕剧集与电影，提供分类浏览、地区年份筛选、完整剧情介绍与演职人员信息，并以专题合集的方式帮你更快找到感兴趣的作品。
          </p>
          <p className="mt-3 text-sm md:text-base text-background-200/90 leading-relaxed">
            本站内容均用于剧情资讯展示与学习交流，不提供在线播放、下载或会员服务。
          </p>
          <div className="mt-7 flex flex-wrap items-center gap-3">
            <Link
              to="/about"
              className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-accent-500 text-primary-950 text-sm font-semibold hover:bg-accent-400 transition-colors cursor-pointer"
            >
              了解我们
            </Link>
            <Link
              to="/contact"
              className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-300/40 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-colors cursor-pointer"
            >
              意见建议
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 md:gap-5">
          {stats.map((s) => (
            <div key={s.label} className="p-5 md:p-6 rounded-lg bg-primary-900 border border-primary-700/60">
              <div className="font-heading text-2xl md:text-3xl font-bold text-accent-400">{s.value}</div>
              <div className="mt-1.5 text-xs md:text-sm text-background-300">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}